import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface LocationListNameHeaderProps
  extends HeaderContext<GatewayLocationModel, GatewayLocationModel['name']> {}

export const LocationListNameHeader = (): // props: LocationListNameHeaderProps,
ReactNode => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return t('delmonicos-shared-sdk.outputs-location.name');
};
